import type { Meta, StoryObj } from "@storybook/react";

import type { SpinnerProps } from "@/ui/core";
import { Spinner } from "@/ui/core";
import type { SpinnerSize } from "@/ui/core/Spinner";
import { ColorToken } from "@/ui/theme/tokens";

const SpinnerVariantValues: Record<SpinnerSize, SpinnerSize> = {
  large: "large",
  small: "small",
};

const StoryMeta: Meta<SpinnerProps> = {
  title: "Core/Spinner",
  component: Spinner,
  argTypes: {
    color: { control: "color" },
    size: {
      control: "select",
      options: Object.values(SpinnerVariantValues),
    },
  },
  args: {
    color: ColorToken.Primary100,
    size: "large",
  },
};

type Story = StoryObj<SpinnerProps>;

export const Primary: Story = {};
export default StoryMeta;
